module.exports = __webpack_public_path__ + "a42581a81916f31c8de41a6544b0eaad.svg";